module.exports = __webpack_public_path__ + "img/potencia_c_red.cb860a44.svg";